import React from "react";
import classNames from "classnames";
import {IWrappedTextComponentProps} from "./types";

export const WrappedTextComponent: React.FC<IWrappedTextComponentProps> = ({
    textComponent,
    modifier
}) => {
    return (
        <span className={classNames("ic_tx", modifier)}>
            {textComponent}
        </span>
    );
};
